'use strict';

module.exports = function (ngModule) {
    ngModule.directive('searchbar', require('./searchbar'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/searchbar/index.js
 **/